import { post, get } from '@/network/db.js'


// 获取企业累计充值额度
export function getTotalRecharge(id) {
    return get(
        'enterpriseInformation/totalRecharge',
        { id }
    );
    /*return request({
        url: 'enterpriseInformation/totalRecharge',
        method: 'get',
        params: {id}
    })*/
}

// 获取企业已分配余额
export function getAllocatedBalance(id) {
    return get(
        'enterpriseUser/allocatedBalance',
        { id }
    );
}

// 获取企业未分配余额
export function getUnallocatedBalance(id) {
    return get(
        'enterpriseInformation/unallocatedBalance',
        { id }
    );
}
// 获取企业交易记录
export function getTransactions(params) {
    return get(
        'enterpriseTransaction/list',
        params
    );
}

// 企业充值
export function recharge(param) {
    return post(
        `enterpriseInformation/recharge`,
        {
            enterpriseId: param.enterpriseId,
            rechargeAmount: param.rechargeAmount,
            type: param.type,
        },
        true,
    );
}
//申请发票
export function Requesapply(params) {
    return get(
        '/enterpriseTransaction/apply',
            params
    );
}
// 支付
export function pay(param) {
    return get(
        `/payment/cashier/pay/${param.paymentMethod}/${param.paymentClient}`,
        {
            orderType: param.orderType,
            sn: param.sn,
            clientType: param.clientType,
        }
    );
}
// 跳转至通联支付
export function tonglianToThirdPay(apiUrl, params) {
    var temp = document.createElement("form");
    temp.action = apiUrl;
    temp.method = "post";
    temp.style.display = "none";

    for (var x in params) {
        var opt = document.createElement("textarea");
        opt.name = x;
        opt.value = params[x];
        temp.appendChild(opt);
    }
    document.body.appendChild(temp);
    temp.submit();
    return temp;
}
